import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const PAGE_PERMISSIONS: Record<string, string> = {
  '': 'DASHBOARD_VIEW', users: 'USER_VIEW_ALL', groups: 'GROUP_VIEW_ALL', permissions: 'PERMISSION_VIEW_ALL',
  'config-scholarships': 'CONFIG_SCHOLARSHIP_VIEW_ALL', settings: 'VIEW_SETTING', reports: 'VIEW_REPORTS',
  'civil-statuses': 'CIVIL_STATUS_VIEW_ALL', 'document-types': 'DOCUMENT_TYPE_VIEW_ALL',
  'education-levels': 'EDUCATION_LEVEL_VIEW_ALL', institutions: 'INSTITUTION_VIEW_ALL',
  'property-types': 'PROPERTY_TYPE_VIEW_ALL', units: 'UNIT_VIEW_ALL',
};

export function canAccessPath(auth: AuthService, path: string): boolean {
  path = path.replace(/^\//, '');
  if (path === 'requirements/new') return auth.isApplicant();
  if (path.startsWith('requirements/') && path.endsWith('/edit')) return auth.isStaff() && auth.hasPermission('VIEW_REQUIREMENTS');
  if (path === 'requirements' || path.startsWith('requirements/')) return auth.hasPermission('VIEW_REQUIREMENTS');
  if (path === 'profile') return true;
  return !auth.isApplicant() && !!PAGE_PERMISSIONS[path] && auth.hasPermission(PAGE_PERMISSIONS[path]);
}

export const permissionGuard: CanActivateChildFn = async (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isLoggedIn()) return router.createUrlTree(['/login']);
  if (!auth.user()?.permissions) await auth.loadCurrentUser();
  if (canAccessPath(auth, state.url.split('?')[0])) return true;
  return router.createUrlTree([auth.hasPermission('VIEW_REQUIREMENTS') ? '/requirements' : '/profile']);
};
